import React from "react";
import { inject, observer } from "mobx-react";

const GooglePayButtonType = (props) => {
  function handleTextChangeSelect(e) {
    const selectedValue = e.target.value;
    props.store.setGooglePayButton({ buttonStyle: selectedValue });
  }
  return (
    <div>
        <div className="col-sm mb-3">
          <div className="form-floating">
            <select
              className="form-control"
              style={{ appearance: 'none'}}
              id="googleButtonStyle"
              name="googleButtonStyle"
              onChange={handleTextChangeSelect}
              value={
                props.store.paymentPage.paymentMethods.settings.googlePay
                  .buttonStyle
              }
              data-qaid="googleButtonStyleInput"
            >
              {props.googlepay.googlePayButtonStyles.map((style) => (
                <option
                  key={style.value}
                  value={style.value}
                  title={style.description}
                >
                  {style.text}
                </option>
              ))}
            </select>
            <label htmlFor="googleButtonStyle">Style</label>
          </div>
        </div>
      </div>
  )
}

export default inject(
  "store",
  "googlepay"
)(observer(GooglePayButtonType));
